module.exports = __webpack_public_path__ + "static/media/tutorial-start-background.41955ceb.svg";